import { chartSeriesColors } from 'utils'
import { appColors } from 'utils'

const DEFAULT_PALETTE = [
  '#44AF69',
  '#3498DB',
  '#FCAB10',
  '#E74C3C',
  '#8FC93A',
  '#9B59B6',
  '#E3BDFA',
  '#C7CB85',
  '#FF7675',
  '#8FB8F6',
  '#1ABC9C',
]

const RAINBOW_PALETTE = ['#95190c', '#d98324', '#d7cf07', '#107e7d', '#3498DB', '#9B59B6', '#044b7f']

export function getDailyActivityColor(index, activity) {
  //Required because rotateColor and slideColor have an opacity value
  if (activity === '2K') return appColors.rotateColor.substring(0, 7)
  if (activity === '2J') return appColors.slideColor.substring(0, 7)

  return getChartSeriesColor(index)
}

export function getChartSeriesColor(index) {
  if (typeof index !== 'number') return getRandomColor()

  if (index < 0) {
    return chartSeriesColors[0]
  }

  if (index < chartSeriesColors.length) {
    return chartSeriesColors[index]
  }

  return getRandomColor()
}

export function getRandomColor() {
  let letters = '0123456789ABCDEF'
  let color = '#'
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }
  return color
}

export function lerpColor(a, b, amount) {
  let ah = parseInt(a.replace(/#/g, ''), 16),
    ar = ah >> 16,
    ag = (ah >> 8) & 0xff,
    ab = ah & 0xff,
    bh = parseInt(b.replace(/#/g, ''), 16),
    br = bh >> 16,
    bg = (bh >> 8) & 0xff,
    bb = bh & 0xff,
    rr = ar + amount * (br - ar),
    rg = ag + amount * (bg - ag),
    rb = ab + amount * (bb - ab)

  return '#' + (((1 << 24) + (rr << 16) + (rg << 8) + rb) | 0).toString(16).slice(1)
}

export function adjustHexOpacity(hexColor, alpha) {
  // Remove the leading '#' if present
  const sanitizedColor = hexColor.replace('#', '')

  // Convert the hex color to RGBA
  const red = parseInt(sanitizedColor.substring(0, 2), 16)
  const green = parseInt(sanitizedColor.substring(2, 4), 16)
  const blue = parseInt(sanitizedColor.substring(4, 6), 16)

  // Convert the alpha value from a range of 0-100 to a range of 0-255
  const alphaValue = Math.round((alpha / 100) * 255)

  // Convert RGBA values to a new hex string
  const updatedHex = `#${((1 << 24) + (red << 16) + (green << 8) + blue).toString(16).slice(1)}${alphaValue.toString(
    16,
  )}`

  return updatedHex
}

export function isValidHex(hex) {
  return /^#(?:[0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}(?:[0-9a-fA-F]{2})?)$/.test(hex)
}

let _colorCtx
function getColorCtx() {
  if (!_colorCtx) _colorCtx = document.createElement('canvas').getContext('2d')
  return _colorCtx
}

function toHex(cssColor) {
  const ctx = getColorCtx()
  ctx.fillStyle = cssColor
  return ctx.fillStyle
}

export function getItemColor(item, index, addOpacity = false) {
  if (item?.color) return item.color
  if (index < DEFAULT_PALETTE.length) return DEFAULT_PALETTE[index] + (addOpacity ? 'A3' : '')
  return toHex(getSeriesColor(index - DEFAULT_PALETTE.length))
}

export function getRainbowColor(index, addOpacity = false) {
  if (index >= RAINBOW_PALETTE.length) {
    return getSeriesColor(index)
  }

  return RAINBOW_PALETTE[index % RAINBOW_PALETTE.length] + (addOpacity ? 'A3' : '')
}

const GOLDEN_ANGLE = 137.50776405003785

const supportsOKLCH = typeof CSS !== 'undefined' && CSS.supports('color', 'oklch(0.7 0.2 0)')

export function getSeriesColor(index) {
  const ring = Math.floor(index / 12)
  const position = index % 12

  const hue = (position * GOLDEN_ANGLE + ring * 15) % 360

  const lightnessLevels = [0.74, 0.68, 0.8, 0.62]
  const chromaLevels = [0.19, 0.16, 0.22, 0.14]

  const l = lightnessLevels[ring % lightnessLevels.length]
  const c = chromaLevels[ring % chromaLevels.length]

  if (supportsOKLCH) {
    return `oklch(${l} ${c} ${hue})`
  }

  const hslLightness = Math.round(l * 100)
  const hslSaturation = Math.round(70 + c * 100)

  return `hsl(${hue}, ${hslSaturation}%, ${hslLightness}%)`
}
